import { isCreditCode, isFloat2 } from '@/common/reg'

export default {
  // RULE: 企业注册名称
  companyRegistrationName: () => [
    { required: true, message: '请填写企业注册名称', trigger: 'blur' },
    { min: 2, max: 200, message: '限制输入2-200个字', trigger: 'blur' }
  ],

  // RULE: 统一社会代码 / 企业注册证编号
  companyUnifiedSocialCreditCode: (isOverseas) => [{
    required: true,
    trigger: 'blur',
    validator: (rule, value, callback) => {
      if (!value) callback(new Error(!isOverseas ? '请填写统一社会代码' : '请填写企业注册证编号'))
      else if (!isOverseas) {
        if (value.length > 18) callback(new Error('输入有误'))
        if (!isCreditCode.test(value)) callback(new Error('输入有误'))
        else callback()
      } else callback()
    }
  }],

  // RULE: 企业注册地址 - 省
  companyProvince: (isOverseas) => isOverseas ? [{ required: false }] : [
    { required: true, message: '请选择地址', trigger: '' }
  ],

  // RULE: 企业注册地址 - 城市
  companyCity: (isOverseas) => isOverseas ? [{ required: false }] : [
    { required: true, message: '请选择地址', trigger: '' }
  ],

  // RULE: 企业注册地址 - 区
  companyDistrict: (isOverseas) => isOverseas ? [{ required: false }] : [
    { required: true, message: '请选择地址', trigger: '' }
  ],

  // RULE: 企业注册地址 - 地址
  companyAddress: () => [
    { required: true, message: '请填写公司详细地址', trigger: 'blur' },
    { min: 0, max: 50, message: '限制输入 50 个字符', trigger: 'blur' }
  ],

  // RULE: 成立日期
  companyEstablishDate: () => [
    { required: true, message: '请选择成立日期', trigger: '' }
  ],

  // RULE: 注册资金
  companyRegisteredCapital: () => [{
    required: true,
    trigger: 'blur',
    validator: (rule, value, callback) => {
      if (!value) callback(new Error('请填写注册资金'))
      else if (!isFloat2.test(value)) callback(new Error('注册资金不正确，请输入正确的注册资金(最多两位小数)'))
      else callback()
    }
  }],

  // RULE: 经营期限 - 起始日期
  companyOperatingPeriodStart: () => [{
    required: true,
    message: '请选择日期',
    trigger: 'change'
  }],

  // RULE: 经营期限 - 结束日期
  companyOperatingPeriodEnd: () => [{
    required: true,
    message: '请选择日期',
    trigger: 'change'
  }],

  // RULE: 经营范围
  companyBusinessScope: () => [
    { required: true, message: '请填写经营范围', trigger: '' }
  ],

  // RULE: 公司规模
  companyEmployeeSize: () => [
    { required: true, message: '请选择公司规模', trigger: '' }
  ],

  // RULE: 纳税人类型
  companyTaxpayerType: (isOverseas) => isOverseas ? [{ required: false }] : [
    { required: true, message: '请选择纳税人类型', trigger: '' }
  ],

  // RULE: 纳税类型税码
  companyTaxpayerTypeCode: (isOverseas) => isOverseas ? [{ required: false }] : [
    { required: true, message: '请选择纳税类型税码', trigger: '' }
  ],

  // RULE: 企业营业执照
  companyBusinessLicenseObjectId: (isOverseas) => [{
    required: true,
    trigger: 'blur',
    validator: (rule, value, callback) => {
      if (!value) callback(new Error(isOverseas ? '请上传企业注册证' : '请上传企业营业执照'))
      else callback()
    }
  }],

  // RULE: 银行开户许可证
  companyOpeningBankAccountPermissionObjectId: () => [{
    required: true,
    trigger: 'blur',
    message: '请上传银行开户许可证'
  }],

  // RULE: 开户银行
  depositBankName: () => [
    { required: true, message: '请选择开户银行', trigger: '' }
  ],

  // RULE: 开户支行
  subbranchBankName: () => [
    { required: true, message: '请填写开户支行', trigger: 'blur' }
  ],

  // RULE: 开户银行账号
  bankAccount: () => [{
    required: true,
    trigger: 'blur',
    validator: (rule, value, callback) => {
      if (!value) return callback(new Error('开户银行账号不能为空'))
      if (!/^[\d]*$/.test(value)) return callback(new Error('银行账号仅支持数字输入'))
      callback()
    }
  }]
}
